
import { useDispatch } from "react-redux";
import { openModalAction } from "_slices/modal";
import styles from './agents.module.css';
import globalStyles from '../result.module.css';
import { modalSet, nextModalSet } from "_slices/view";
import { useRouter } from 'next/navigation'
import { useState, useEffect } from "react";
import miscEvent from 'lib/ga/miscEvent';
import showAllAgentContacts from 'lib/ga/showAllAgentContacts';

interface Props {
  agents: any;
  contactable: boolean
  sponsored: boolean
  title: string,
  id: number,
  type: string,
  display: string,
  showAllAgentContacts: boolean,
  property: object,
  isLoggedIn: boolean,
  showRibbon: boolean,
  contactButtonAll: boolean,
  contactType: string
}
const AgentsList = ({ agents, contactable, title, sponsored, contactType, id, type, display, showAllAgentContacts = false, property, isLoggedIn, showRibbon = false, contactButtonAll = true }: Props) => {
  let dispatch = useDispatch();
  const router = useRouter();
  const [isHover, setIsHover] = useState(false);

  let agentList = agents;


  if (display === 'agents' && !contactable) {
    agentList = agents.filter(agent => agent.paying_client)
  }

  if (!agentList) return null;
  return (
    <div id="agent-contain" className={`${styles.GridContainer} ${styles.marginBottom}`}>
      {
        showRibbon && <div className={styles.ribbon}
          onMouseEnter={() => {
            setIsHover(true)
          }}
          onMouseLeave={() => {
            setIsHover(false)
          }}
        >CR+ Access</div>
      }

      {isHover && <div className={styles.messageContainer}>
        <div className={`${globalStyles.smallText}`}>
          <strong>CR+ Access</strong>: You are seeing these contacts because you're logged in as an agent to Completely Retail with a premium subscription. These agents are not visible to regular visitors.
        </div>
      </div>
      }
      <div className={styles.gridRow}>
        <h3 className={globalStyles.subTitleText}>{title || 'Agents'}</h3>
      </div>
      <div className={`${styles.contentRow} ${agents.length > 1 ? styles.smallVersion : ''}`}>
        {agentList.map((agent, i) => {
          const isLastRow = agentList.length > 2 ? i >= agents.length - (agents.length % 2 || 2) : true;

          return (
            <AgentListItem loggedIn={isLoggedIn} includeBorder={!isLastRow} contactType={contactType} property={property} showAllAgentContacts={showAllAgentContacts} key={agent.company_id} company={agent} contactable={contactable} sponsored={sponsored} id={id} type={type} display={display} />
          );
        })}
      </div>
      {contactButtonAll && (
        <div className={styles.buttonContainerContactAgent}>
          <button className={styles.smallButton} onClick={(e) => {
            if (isLoggedIn) {
              dispatch(
                modalSet({
                  visible: true,
                  type: "contactProperty",
                  view: id,
                  router
                })
              );
            } else {
              dispatch(
                modalSet({
                  visible: true,
                  type: "auth",
                  view: "register",
                  router,
                  propertyPage: true
                })
              );
              dispatch(
                nextModalSet({
                  visible: true,
                  type: "contactProperty",
                  view: id.toString(),
                  router
                })
              );
            }
          }}>
            Make an enquiry
          </button>
        </div>
      )}

    </div>
  );
};

export default AgentsList;


const Company = ({ company, contactable, sponsored, id, type, property, contactType, loggedIn }) => {
  let dispatch = useDispatch();
  const [displayAgentsProps, setDisplayAgentsProps] = useState(null);
  const router = useRouter();
  useEffect(() => {
    if (loggedIn && displayAgentsProps !== null) {
      dispatch(
        openModalAction({
          componentName: "AgentContactInfomation",
          componentProps: displayAgentsProps,
        })
      );
    }
  }, [loggedIn, displayAgentsProps]);

  let filteredUsers = company.users.filter(user => user.contacts && user.contacts.length > 0);
  return (
    <div className={styles.companyContainer}>
      <div className={styles.companyLeft}>
        {company.logo_uri &&
          <div className={styles.companyLogo}>
            <img alt={`${company.company_name} logo`} src={`${process.env.NEXT_PUBLIC_APP_MEDIA_URL}${company.logo_uri}`} loading="lazy" height="auto" width="auto"></img>
          </div>
        }
        {
          !company.logo_uri && (
            <p>{company.company_name}</p>
          )
        }
      </div>
      <div className={styles.companyBorder} />
      <div className={styles.agentDetails}>
        {(() => {
          if (contactable && filteredUsers && filteredUsers.length > 0) {
            return (
              <button
                className={styles.callButton}
                onClick={() => {
                  const log = {
                    result_id: id,
                    subject_type: type,
                    contact_type: contactType,
                    contact_target: company.company_id
                  };

                  showAllAgentContacts(log);

                  if (loggedIn) {
                    dispatch(
                      openModalAction({
                        componentName: "AgentContactInfomation",
                        componentProps: {
                          title: 'Contact Agent',
                          agent: [],
                          company,
                          active: id,
                          sponsored,
                          type,
                          property
                        },
                      })
                    );
                  } else {
                    dispatch(
                      modalSet({
                        visible: true,
                        type: "auth",
                        view: "register",
                        router,
                        propertyPage: true
                      })
                    );
                    setDisplayAgentsProps({
                      title: 'Contact Agent',
                      agent: [],
                      company,
                      active: id,
                      sponsored,
                      type,
                      property
                    });
                  }
                }}
              >
                Get in touch
              </button>
            );
          } else {
            return <p>{company.company_name}</p>;
          }
        })()}
      </div>
    </div>
  );
};



const AgentListItem = ({ company, contactable, sponsored, loggedIn, id, type, display, contactType, property, includeBorder }) => {
  return (
    <div className={`${styles.agentSlideContainer} ${includeBorder ? styles.borderBottom : ''}`}>
      <div className={styles.companyPadder}>
        <Company loggedIn={loggedIn} company={company} contactable={true} sponsored={sponsored} id={id} type={type} property={property} contactType={contactType} />
      </div>
    </div>
  );
};
